import { Instance } from 'mobx-state-tree';
import { RouteStopUnscheduledDtoModelBase } from './RouteStopUnscheduledDtoModel.base';

/* The TypeScript type of an instance of RouteStopUnscheduledDtoModel */
export interface RouteStopUnscheduledDtoModelType extends Instance<typeof RouteStopUnscheduledDtoModel.Type> {}

/* A graphql query fragment builders for RouteStopUnscheduledDtoModel */
export { selectFromRouteStopUnscheduledDto, routeStopUnscheduledDtoModelPrimitives, RouteStopUnscheduledDtoModelSelector } from './RouteStopUnscheduledDtoModel.base';

/**
 * RouteStopUnscheduledDtoModel
 *
 * Route unscheduled event
 */
export const RouteStopUnscheduledDtoModel = RouteStopUnscheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
